export const baseURL = "https://lehgu.de/expressLehgu/"
export const userUploadURL = "https://lehgu.de/prof_cms/fileadmin/user_upload/"
export const imageBaseURL = "https://lehgu.de/prof_cms/fileadmin/images/"
export const imageBaseLehguURL = "https://lehgu.de/prof_cms/fileadmin/lehgu/images/"

export const imageLehguMedia = "https://lehgu.de/prof_cms/fileadmin/lehgu/media/"
export const audioBaseURL = "https://lehgu.de/prof_cms/fileadmin/lehgu/audios/"
export const audioUserUploadURL = "https://lehgu.de/prof_cms/fileadmin/user_upload/"
export const videoBaseURL = "https://lehgu.de/prof_cms/fileadmin/lehgu/videos/"

// static file links
export const staticFileLinks = {
    613 : "https://lehgu.de/cms/fileadmin/lehgu/files/Blocksatz_Cheat%20Sheet_GESUNDERHALTUNG%20DER%20STIMME.pdf",
}

export const jwtName = "jwt_prof"

// IDs of special pages
export const lerneinheitenOverviewPageID = 315  // TODO: receive from backend on initial request!
export const techIntroPageID = 509  // TODO: receive from backend on initial request!
export const contentIntroPageID = 507  // TODO: receive from backend on initial request!
export const erfahrenSieMehrPageID = 363  // TODO: receive from backend on initial request!
export const lehguPlusPageID = 505

export const basename = "/prof"
// multiple choice parsing tokens
export const quizParsingToken_Frage = "_F_"
export const quizParsingToken_Antworten = "_A_"
export const quizParsingToken_antwort = "_a_"
export const quizParsingToken_Korrekt = "_K_"
// drag n drop parsing tokens
export const quizParsingToken_dnd = "_dnd_"
export const quizParsingToken_dno = "_dno_"
export const quizParsingToken_drags = "_drag_"
export const quizParsingToken_drops = "_drop_"
export const quizParsingToken_dragdropUnit = "_d_"
export const quizParsingToken_message = "_msg_"
export const quizParsingToken_correct = "_+_"
export const quizParsingToken_wrong = "_-_"
export const quizParsingToken_height = "_H_"

// TODO missing svgs
export const categoryToIconMapper = {
    14: "prefix_video.svg",
    15: "prefix_text.svg",      //
    16: "prefix_audio.svg",
    17: "prefix_quiz.svg",
    18: "prefix_uebung_audio.svg",      
    19: "prefix_uebung_video.svg",
    20: "prefix_text.svg",      //
    21: "prefix_erklaerfilm.svg",
    22: "prefix_reflexion.svg",
    23: "prefix_text.svg",      //
    24: "prefix_text.svg",      //
    25: "prefix_text.svg",      //
    26: "logo-lehgu-plus-klein.svg",
    27: "prefix_text.svg",      //
}

export const lehguPlusImageURL = "https://lehgu.de/prof_cms/fileadmin/images/prefix_exkurs_sehr_gro%C3%9F-quadrat.jpg"

export const KOMPASS_SVG_URL = "https://lehgu.de/prof_cms/fileadmin/images/button-kompass.svg"
export const LEHGU_LOGO_URL = "https://lehgu.de/prof_cms/fileadmin/lehgu/images/logo.svg"
export const INHALTINFO_SVG_URL = "https://lehgu.de/prof_cms/fileadmin/lehgu/images/Icon_inhalt_info.svg"
export const TECHNISCHEINFO_SVG_URL = "https://lehgu.de/prof_cms/fileadmin/lehgu/images/Icon_technisch_info.svg"
export const LERNEINHEITEN_SVG_URL = "https://lehgu.de/prof_cms/fileadmin/lehgu/images/inhalt.svg"
export const LOGOUT_SVG_URL = "https://lehgu.de/prof_cms/fileadmin/lehgu/images/logout.svg"
export const BOOKMARK_SVG = "https://lehgu.de/images/bookmark.svg"

// colors
// red rgb(214 11 82 / 77%);